<template>
  <div>
    <add-influencer :is-active.sync="isAdding" @added="influencerAdded" />
    <data-table
      title="Criminal Cases"
      ref="table"
      :url="url"
      :headers="headers"
      searchable
      :csv="false"
      :archive="false"
      @click:row="showDetails"
      @rowClicked="showDetails"
    >
      <span slot="item.type" slot-scope="{ item }" v-text="getUserType(item)" />

      <template slot="item.status">
        <v-chip>Frozen</v-chip>
      </template>
    </data-table>
  </div>
</template>
<script>
export default {
  data() {
    return {
      currentFilter: "all",
      isAdding: false,
      showArchived: false,
      url: "api/v1/criminalCases",
      headers: this.pairTableLabelWithValue({
        "Creation date": "client.owner.created_at",
        "Activation date": "client.owner.activated_at",
        "Freeze date": "created_at",
        "Last name": "client.owner.last_name",
        "First name": "client.owner.first_name",
        "Country": "client.owner.country",
        "Phone number": "client.owner.full_phone_number",
        Email: "client.owner.email",
        Status: "status",
      }),
    };
  },
  watch: {
    url() {
      this.$nextTick(() => {
        this.$refs.table.fetchData();
      });
    },
  },
  methods: {
    showDetails(criminalCase) {
      this.$router.push({
        name: "users.show",
        params: { id: criminalCase.client.owner_id },
      });
    },
  },
};
</script>
